import { defineComponent as _defineComponent } from 'vue'
import '@/components/article-editor/ArticleEditor/PublishArticleButton/PublishArticleButton.scss';
import EventBus from '@/EventBus';
import { ARTICLE_EDITOR_FORCE_FLUSH } from '@/events';

import { Workspace } from '@/models/Workspace';
import router from '@/router';
import { DRAFTS } from '@/routerNames';
import articleEditService from '@/services/article/ArticleEditService';
import articleModeService from '@/services/article/ArticleModeService';
import notificationService from '@/services/NotificationService';
import urlService from '@/services/UrlService';
import store from '@/store';
import { commitSetArticleEditorIsPublishingDisabled } from '@/store/commits/articleEditorCommits';
import { dispatchSaveArticle } from '@/store/dispatchers/articleEditorDispatchers';
import { ArticleEditorState } from '@/store/state/ArticleEditorState';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublishArticleButton',
  setup(__props) {

const SAVE_ARTICLE_TIMEOUT = 500; // this timeout must be bigger then TIP TAP update content timeout

const isPublishingDisabled = computed(
  (): boolean => store.state.articleEditor.isPublishingDisabled || store.state.articleEditor.isVideoProcessing
);

const getArticleEditorWorkspace = computed((): Workspace => articleEditService.articleWorkspace);

const getArticleEditor = computed((): ArticleEditorState => articleEditService.articleEditor);

const checkFieldValidation = computed((): boolean => !!(isValid('title') && isValid('workspace')));

const isWorkspacePersonal = computed((): boolean => {
  if (!getArticleEditorWorkspace.value) return true;
  return getArticleEditorWorkspace.value.visibility === 'personal';
});

const isValid = (key: 'workspace' | 'title') => getArticleEditor.value.article[key];

const save = async (publish = false, isNotification = false) => {
  if (store.state.articleEditor.isPublishingDisabled) return;

  if (checkFieldValidation.value) {
    commitSetArticleEditorIsPublishingDisabled(true);
    EventBus.$emit(ARTICLE_EDITOR_FORCE_FLUSH);

    await new Promise((resolve) => {
      window.setTimeout(resolve, SAVE_ARTICLE_TIMEOUT);
    });
    await dispatchSaveArticle(publish, isNotification);
    commitSetArticleEditorIsPublishingDisabled(false);
  } else {
    const emptyField = getArticleEditor.value.article.title ? 'workspace' : 'title';
    notificationService.error(`Article ${emptyField} can not be empty`);
  }
};

const onSaveAsDraft = async () => {
  const article = getArticleEditor.value.article;
  const workspace = getArticleEditor.value.workspace;

  await articleEditService.saveAsDraft();
  if (article.draft && !article.original) {
    await router.push({ name: DRAFTS });
  } else {
    const mode = articleModeService.getArticleMode(article);
    await router.push(urlService.getArticleViewRoute(article, workspace, mode));
  }
};

return { __sfc: true,SAVE_ARTICLE_TIMEOUT, isPublishingDisabled, getArticleEditorWorkspace, getArticleEditor, checkFieldValidation, isWorkspacePersonal, isValid, save, onSaveAsDraft }
}

})